"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.minBar = exports.maxBar = void 0;
const getFloatingAxisDataSet = (extractedDatasets, date) => extractedDatasets.map(data => data.data.filter(dataset => date === dataset.key)[0].value);
const getDataSet = extractedDatasets => extractedDatasets.map(data => data.data.map(data => data.value === null ? 0 : data.value)).flat();
const filterAndSortDataSet = dataSet => dataSet.filter(Number.isFinite).sort((a, b) => a < b ? -1 : 1);
const maxBar = function (extractedDatasets, floatingAxis, date) {
  const dataSet = floatingAxis ? getFloatingAxisDataSet(extractedDatasets, date) : getDataSet(extractedDatasets);
  return filterAndSortDataSet(dataSet).pop();
};
exports.maxBar = maxBar;
const minBar = function (extractedDatasets, floatingAxis, date) {
  const dataSet = floatingAxis ? getFloatingAxisDataSet(extractedDatasets, date) : getDataSet(extractedDatasets);
  return filterAndSortDataSet(dataSet).shift();
};
exports.minBar = minBar;